document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('[data-menu-toggle]');
  var menu=document.querySelector('[data-mobile-menu]');
  /* Menu interaction is handled by besneaker-drawer.js. */
  document.querySelectorAll('[data-quantity]').forEach(function(input){input.addEventListener('change',function(){if(Number(input.value)<0)input.value=0;});});
});
/* BESNEAKER: accessible product gallery with arrow, thumbnails and touch swipe. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    const images = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const counter = gallery.querySelector('[data-gallery-counter]');
    let active = 0, startX = 0;
    function show(index) {
      if (!images.length) return;
      active = (index + images.length) % images.length;
      images.forEach((img, i) => { img.hidden = i !== active; img.classList.toggle('is-active', i === active); });
      thumbs.forEach((btn, i) => { btn.classList.toggle('is-active', i === active); btn.setAttribute('aria-pressed', i === active ? 'true' : 'false'); });
      if (counter) counter.textContent = (active + 1) + ' / ' + images.length;
    }
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(active - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(active + 1));
    thumbs.forEach((btn, i) => btn.addEventListener('click', () => show(i)));
    gallery.addEventListener('touchstart', e => { startX = e.changedTouches[0].screenX; }, {passive:true});
    gallery.addEventListener('touchend', e => {
      const delta = e.changedTouches[0].screenX - startX;
      if (Math.abs(delta) > 45) show(active + (delta < 0 ? 1 : -1));
    }, {passive:true});
    show(0);
  });
});
